import { errorValidation } from './utils';

let orderTelInput = $("#order_phone");

orderTelInput.intlTelInput({
    initialCountry: 'it',
    placeholderNumberType: 'aggressive',
    utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/11.0.14/js/utils.js",
    separateDialCode: true,
    preferredCountries: ["it"],
    onlyCountries: ["ro", "de", "us", "md", "it"]
});

// on blur: validate
orderTelInput.focusout(function () {
    if ($.trim(orderTelInput.val())) {
        if (orderTelInput.intlTelInput("isValidNumber")) {
            console.log(window.translations.phoneInvalid);
        } else {
            orderTelInput.addClass("_error");
        }
    }
});

// on keydown: reset
orderTelInput.keydown(function () {
    orderTelInput.removeClass("_error");
});

$.validator.addMethod('validateOrderPhone', function () {
    if (orderTelInput.intlTelInput("isValidNumber")) {
        return true;
    } else {
        return false;
    }
}, window.translations.phoneInvalid);

(() => {
    const $form = $("form[name='order']");
    $form.validate({
        ignore: [],
        ...errorValidation,
        errorClass: 'label-error',
        rules: {
            'order[name]': {
                required: true,
            },
            'order[email]': {
                required: true,
                email:true,
            },
            'order[phone]': {
                required: true,
                validateContactPhone: true,
            },
            'order[address]': {
                required: true,
            },
            'order[postal_code]': {
                required: true,
            },
            'order[payment_type]': {
                required: true
            },
            'order[delivery_type]': {
                required: true
            },
        },
        messages: {
            'order[name]': {
                required: window.translations.required,
            },
            'order[email]': {
                required: window.translations.required,
                email: window.translations.emailInvalid,
            },
            'order[phone]': {
                required: window.translations.required,
                validateContactPhone: window.translations.phoneInvalid,
            },
            'order[address]': {
                required: window.translations.required,
            },
            'order[postal_code]': {
                required: window.translations.required,
            },
            'order[payment_type]': {
                required: window.translations.required,
            },
            'order[delivery_type]': {
                required: window.translations.required,
            },
        },
        submitHandler: (form) => {
            form.submit();
        },
        success: function (label) {
            let name = label.attr('for');
            label.text('');
        },
    });
})();
